import { render, staticRenderFns } from "./OpentpList.vue?vue&type=template&id=7c7d391f"
import script from "./OpentpList.vue?vue&type=script&lang=js"
export * from "./OpentpList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports